export function loadAddressList() {
  return {
    type: 'LOAD_ADDRESS_LIST',
  };
}

export function loadAddressListCompletion(error, list) {
  return {
    type: 'LOAD_ADDRESS_LIST_COMPLETION',
    error,
    list,
  };
}

export function filterAddressList(query) {
  return {
    type: 'FILTER_ADDRESS_LIST',
    query,
  };
}

export function changeDefAddress(addressId) {
  return {
    type: 'CHANGE_DEF_ADDRESS',
    addressId,
  };
}

export function changeDefAddressCompletion(addressId, error) {
  return {
    type: 'CHANGE_DEF_ADDRESS_COMPLETION',
    addressId,
    error,
  };
}

export function deleteAddress(addressId) {
  return {
    type: 'DELETE_ADDRESS',
    addressId,
  };
}

export function deleteAddressCompletion(addressId, error) {
  return {
    type: 'DELETE_ADDRESS_COMPLETION',
    addressId,
    error,
  };
}

export function syncAddressEditInput(input, reset) {
  return {
    type: 'SYNC_ADDRESS_EDIT_INPUT',
    input,
    reset,
  };
}

export function editAddress(addressId) {
  return {
    type: 'EDIT_ADDRESS',
    addressId,
  };
}

export function editAddressCompletion(addressId, error, data) {
  return {
    type: 'EDIT_ADDRESS_COMPLETION',
    addressId,
    data,
    error,
  };
}

export function syncOrderDetailAddressInput(input, reset) {
  return {
    type: 'SYNC_ORDER_DETAIL_ADDRESS_INPUT',
    input,
    reset,
  };
}

export function saveOrderDetailAddress(orderId) {
  return {
    type: 'SAVE_ORDER_DETAIL_ADDRESS',
    orderId,
  };
}

export function saveOrderDetailAddressCompletion(error) {
  return {
    type: 'SAVE_ORDER_DETAIL_ADDRESS_COMPLETION',
    error
  };
}
